import { cn } from '@execonline-inc/execonline-ui';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLink } from '../../LinkyLinky';
import { rootResourceStore } from '../../RootResourceStore';
import { T } from '../../Translations';
import CopyrightNotice from './CopyrightNotice';
import Divider from './Divider';

interface FooterProps {
  className?: string;
}

const Footer: React.FC<FooterProps> = ({ className = 'text-center' }) =>
  just({})
    .assign('privacyLink', findLink('privacy')(rootResourceStore.links))
    .assign('termsLink', findLink('terms_and_conditions')(rootResourceStore.links))
    .map(({ privacyLink, termsLink }) => (
      <div
        className={cn('p-2.5 text-gray-600', className)}
        data-test-footer={true}
        role="contentinfo"
      >
        <CopyrightNotice />
        <Divider />
        <T
          kind="<link1>Privacy ..."
          link1={(content) => (
            <a
              href={privacyLink.href}
              target="_blank"
              rel="noopener noreferrer"
              data-test-privacy-policy-link={true}
              className="font-semibold underline hover:text-gray-900"
            >
              {content}
            </a>
          )}
        />
        <Divider />
        <T
          kind="<link1>Terms ..."
          link1={(content) => (
            <a
              href={termsLink.href}
              target="_blank"
              rel="noopener noreferrer"
              data-test-terms-of-use-link={true}
              className="font-semibold underline hover:text-gray-900"
            >
              {content}
            </a>
          )}
        />
      </div>
    ))
    .getOrElse(() => <></>);

export default observer(Footer);
